// extracted by mini-css-extract-plugin
export var factoid = "styles-module--factoid--bbe04";
export var image = "styles-module--image--7d4e6";
export var interactive = "styles-module--interactive--349d5";
export var invert = "styles-module--invert--b5954";
export var text = "styles-module--text--c6861";